import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import isIdApp from "../../utils/isIdApp";

export default function IdApp({ children }) {
	const navigate = useNavigate(); // Đổi tên thành navigate cho chuẩn

	useEffect(() => {
		if (!isIdApp()) {
			navigate("/app");
		}
	}, [navigate]); // THÊM navigate vào đây để fix lỗi build

	return children;
}
